import { useSetAtom } from 'jotai';
import {
    currentCategoryAtom,
    type CurrentCategoryType,
} from '../states/current-category-atom';

/**
 * Hook to easily manage the current category state across the application.
 * Use this hook in route components to set the current category when the route loads.
 */
export const useCurrentCategory = () => {
    const setCurrentCategory = useSetAtom(currentCategoryAtom);

    /**
     * Set the current category. This will update the navigation highlighting.
     * @param category - The category to set as current
     */
    const setCategory = (category: CurrentCategoryType) => {
        setCurrentCategory(category);
    };

    return {
        setCategory,
    };
};
